import { render, staticRenderFns } from "./ProductsSwitch_comp.vue?vue&type=template&id=7759879e&"
import script from "./ProductsSwitch_comp.vue?vue&type=script&lang=js&"
export * from "./ProductsSwitch_comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports